<div class="pricing-backdrop">
  <div class="pricing-modal">

    <button class="close-btn" aria-label="Close" (click)="close()">
      <i class="bi bi-x-lg"></i>
    </button>

    <div class="top-icon">
      <i class="bi bi-lock"></i>
    </div>

    <p class="text-center">This interview round is available in the paid plan. Please upgrade to continue.</p>
    <button class="btn-add w-100" (click)="goToUpgradePlan()">Upgrade Now</button>
  </div>
</div>